module.exports = __webpack_public_path__ + "static/media/escoger_casa.a2095749.png";